module.exports = __webpack_public_path__ + "assets/iconfont.f12bd682.woff";